import { Component, ElementRef, EventEmitter, Input, ViewChild } from '@angular/core';
import { MainService } from 'app/_services/main.service';

@Component({
  selector: 'app-vrooam-return-policy-settings',
  templateUrl: './vrooam-return-policy-settings.component.html',
  styleUrl: './vrooam-return-policy-settings.component.scss'
})
export class VrooamReturnPolicySettingsComponent {
  @ViewChild('newKeyInput') newKeyInput!: ElementRef<HTMLInputElement>;
  @Input() label: string;
  private _model: { [key: string]: number };
  @Input()
  set model(value: { [key: string]: number }) {
    this._model = value;
    this.initFocusInputs();
  }
  get model(): { [key: string]: number } {
    return this._model;
  }
  new = '';
  newKeyValue = 'pop';
  focusKeyInput: { [key: string]: EventEmitter<boolean> } = {};
  focusValueInput: { [key: string]: EventEmitter<boolean> } = {};

  constructor(
    public mainService: MainService
  ) {

  }

  initFocusInputs(): void {
    Object.keys(this.model).forEach(key => {
      if (!this.focusKeyInput[key]) this.focusKeyInput[key] = new EventEmitter<boolean>();
      if (!this.focusValueInput[key]) this.focusValueInput[key] = new EventEmitter<boolean>();
    });
    if (!this.focusKeyInput[this.newKeyValue]) this.focusKeyInput[this.newKeyValue] = new EventEmitter<boolean>();
    if (!this.focusValueInput[this.newKeyValue]) this.focusValueInput[this.newKeyValue] = new EventEmitter<boolean>();
  }

  getValueForKey(key: string): number {
    return this.model[key] || 0;
  }

  keyExists(key: string): boolean {
    return this.model.hasOwnProperty(key);
  }

  setValueForKey(key: string, value: number, defaultValue = 0): void {
    if (defaultValue && !value) value = defaultValue;
    this.model[key] = +value;
    if (key === this.newKeyValue) this.new = '';
    this.setFocus(key, true);
  }

  getOtherKeys(key: string): string[] {
    return Object.keys(this.model).filter(k => k !== key);
  }

  changeKeyAndValue(key: string, newKey: string): void {
    const value = this.getValueForKey(key);
    if (key !== newKey && !this.keyExists(newKey)) {
      delete this.model[key];
      delete this.focusKeyInput[key];
      delete this.focusValueInput[key];
      this.model[newKey] = value;
      this.focusKeyInput[newKey] = new EventEmitter<boolean>();
      this.focusValueInput[newKey] = new EventEmitter<boolean>();
      if (key === this.newKeyValue) this.new = '';
      this.setFocus(newKey);
    }
  }

  addNewKey(): void {
    this.new = this.newKeyValue;
    this.setFocus(this.new);
    setTimeout(() => {
      this.newKeyInput.nativeElement.select();
    }, 0);
  }

  deleteKey(key: string): void {
    this.mainService.confirmBox(`Weet u zeker dat u deze popcode instelling wilt verwijderen?`)
      .subscribe(yes => {
        if (yes) {
          delete this.model[key];
          delete this.focusKeyInput[key];
          delete this.focusValueInput[key];
        }
      });
  }

  setFocus(key: string, focusValue: boolean = false): void {
    if (!focusValue) {
      setTimeout(() => {
        this.focusKeyInput[key].emit(true);
      }, 0);
    } else {
      setTimeout(() => {
        this.focusValueInput[key].emit(true);
      }, 0);
    }
  }

}
